import { request } from '@/utils/request';

// 获取公告列表（国械头条 / 质量公告共用）
export const getIndexAnnouncement = params => {
	return request({ url: '/cms/public/indexAnnouncement', method: 'GET', params: params });
};

// 获取公告详情
export const getDetailAnnouncement = params => {
	return request({ url: '/cms/public/detailAnnouncement', method: 'GET', params: params });
};

/**
 * 构造公告列表请求参数
 * - 质量公告（quantity）：noticeType
 * - 国械头条（hot）：theTt / theMaster，isGxzz 时为国械智造头条
 * @param {Object} options
 * @param {'hot'|'quantity'} options.pageType 频道
 * @param {number} options.pageNumber 页码
 * @param {number} options.pageSize 每页条数
 * @param {number} [options.companyId] 站点 ID
 * @param {number|string} [options.noticeType] 质量公告类型
 * @param {boolean} [options.isGxzz] 是否国械智造
 */
export function buildNoticeListParams({ pageType, pageNumber, pageSize, companyId = 1, noticeType, isGxzz }) {
	const base = { pageNumber, pageSize, companyId };

	if (pageType === 'quantity') {
		return { ...base, noticeType: noticeType ?? '' };
	}
	return { ...base, theTt: 1, theMaster: 1, ...(isGxzz ? { isGxzz: 1 } : {}) };
}
